/* Bisou Rivage — galerie produit en diapos : cercles + flèches (Standby 3A, 19/10/2026 ; base du 17/06).
 * Le défilement (doigt, trackpad, flèches) reste celui du <slider-component> natif.
 * Ce fichier ajoute :
 *   - les cercles, refaits à chaque fois que la liste change (le thème remplace la vue principale à chaque
 *     variante : des cercles pris une fois pour toutes pointeraient sur des diapos disparues) ;
 *   - le choix de la diapo après un changement de variante :
 *       sur une scène que ce changement modifie (format, couleur du cadre) -> on reste dessus, on voit le cadre
 *       changer de taille ou de couleur dans la pièce ;
 *       sinon (vue principale, « Sans cadre » vu depuis une scène) -> retour à la vue principale, qui montre le choix.
 *   - les flèches du clavier quand la galerie a le focus ;
 *   - le zoom (« Agrandir ») qui montre toujours l'image de la vue principale (19/10) ;
 *   - le glisser à la souris, et le centrage dans la partie visible du bloc gris (20/10).
 * Ne touche ni au panier, ni aux variantes. Réversible : retirer ce fichier et l'attribut data-bisou-gallery. */
(function () {
  'use strict';
  var SVG_PREV = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 12H4M10 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SVG_NEXT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12h16M14 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function init() {
    var root = document.querySelector('[data-bisou-gallery="slider"]');
    if (!root) return;
    var list = root.querySelector('.product__media-list');
    var viewer = root.querySelector('slider-component');
    if (!list || !viewer) return;
    var nav = root.querySelector('.slider-buttons');

    function slides() {
      return Array.prototype.filter.call(list.children, function (li) {
        return li.matches && li.matches('li.product__media-item') && li.offsetParent !== null;
      });
    }

    var pv = root.querySelector('.slider-button--prev .svg-wrapper') || root.querySelector('.slider-button--prev');
    var nx = root.querySelector('.slider-button--next .svg-wrapper') || root.querySelector('.slider-button--next');
    if (pv) pv.innerHTML = SVG_PREV;
    if (nx) nx.innerHTML = SVG_NEXT;

    var dots = document.createElement('div');
    dots.className = 'bisou-gdots';
    if (nav) {
      var counter = nav.querySelector('.slider-counter');
      nav.insertBefore(dots, counter ? counter.nextSibling : nav.firstChild);
    } else {
      root.appendChild(dots);
    }

    function libelle(li, i) {
      var s = li.getAttribute('data-bisou-scene-nom');
      return s ? s : (i === 0 ? (root.getAttribute('data-bisou-label-main') || 'Vue 1') : ('Vue ' + (i + 1)));
    }

    function aller(li, doux) {
      if (!li) return;
      var rl = list.getBoundingClientRect(), r = li.getBoundingClientRect();
      var gauche = Math.max(0, Math.round(list.scrollLeft + (r.left - rl.left) - list.clientLeft));
      /* mouvement réduit : la diapo arrive sans glisser */
      var calme = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (doux !== false && !calme) { list.scrollTo({ left: gauche, behavior: 'smooth' }); return; }
      /* sans glisser : la liste a scroll-behavior: smooth, « auto » glisserait quand même */
      var sb = list.style.scrollBehavior;
      list.style.scrollBehavior = 'auto';
      list.scrollLeft = gauche;
      list.style.scrollBehavior = sb;
    }

    /* le haut du cadre le plus grand de chaque scène, en part de sa hauteur (snippets/bisou-scenes.liquid) : la CSS
       descend la scène juste assez pour le garder entier sur un écran bas (bisou-product-gallery.css, 4.) */
    var hautsCadres = null;
    function cadrer() {
      if (!hautsCadres) {
        hautsCadres = {};
        try {
          var js = document.querySelector('script[data-bisou-scenes]');
          (js ? JSON.parse(js.textContent).scenes : []).forEach(function (sc) {
            if (!sc || !sc.formats) return;
            var h = 1;
            Object.keys(sc.formats).forEach(function (f) {
              var c = sc.formats[f].c || [];
              for (var i = 1; i < c.length; i += 2) h = Math.min(h, c[i]);
            });
            if (h < 1) hautsCadres[sc.id] = h.toFixed(4);
          });
        } catch (e) {}
      }
      Array.prototype.forEach.call(list.querySelectorAll('.bisou-scene-slide[data-bisou-scene]'), function (li) {
        var h = hautsCadres[li.getAttribute('data-bisou-scene')];
        if (h && li.style.getPropertyValue('--bs-cadre-haut') !== h) li.style.setProperty('--bs-cadre-haut', h);
      });
    }

    function construire() {
      cadrer();
      var s = slides();
      /* le ratio de la vue principale fixe la largeur de la galerie (bisou-product-gallery.css) */
      var c0 = s[0] && s[0].querySelector('.product-media-container');
      var ratio = c0 && parseFloat(c0.style.getPropertyValue('--ratio'));
      if (ratio > 0) root.style.setProperty('--bg-ratio', String(ratio));
      dots.innerHTML = '';
      root.classList.toggle('bisou-gallery--multi', s.length > 1);
      if (nav) nav.hidden = s.length < 2;
      if (s.length < 2) return;
      s.forEach(function (li, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bisou-gdot';
        b.setAttribute('aria-label', libelle(li, i));
        b.addEventListener('click', function () { aller(li); });
        dots.appendChild(b);
      });
      marquer();
    }

    function courante() {
      var s = slides();
      if (!s.length) return null;
      var r0 = list.getBoundingClientRect();
      var mid = r0.left + r0.width / 2, best = s[0], bd = Infinity;
      s.forEach(function (li) {
        var r = li.getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - mid);
        if (d < bd) { bd = d; best = li; }
      });
      return best;
    }

    /* cinq points au plus, le point actif au milieu ; la rangée glisse d'un point à chaque diapo, comme sur Instagram.
       Le dernier point visible de chaque côté, s'il y en a d'autres derrière, est plus petit et plus pâle ; ceux
       d'au-delà sont cachés (Max, 28/10, 19 h 30 : « on limite à 5 et le dernier un peu moins opaque […] qu'on sente » ;
       fiche c28b-galerie-points). La CSS fait glisser la rangée (--gd-dec). */
    var FENETRE = 5;
    function fenetre(actif) {
      var n = dots.children.length, debut = 0;
      var serre = n > FENETRE;
      if (serre) debut = Math.max(0, Math.min(actif - Math.floor(FENETRE / 2), n - FENETRE));
      var fin = debut + FENETRE - 1;
      dots.classList.toggle('bisou-gdots--fenetre', serre);
      if (serre) dots.style.setProperty('--gd-dec', String(debut));
      else dots.style.removeProperty('--gd-dec');
      for (var i = 0; i < n; i++) {
        var d = dots.children[i];
        d.classList.toggle('is-hors', serre && (i < debut || i > fin));
        d.classList.toggle('is-bord', serre && ((i === debut && debut > 0) || (i === fin && fin < n - 1)));
      }
    }

    function marquer() {
      var s = slides(), c = courante(), actif = 0;
      for (var i = 0; i < dots.children.length; i++) {
        var on = s[i] === c;
        if (on) actif = i;
        dots.children[i].classList.toggle('is-active', on);
        if (on) dots.children[i].setAttribute('aria-current', 'true');
        else dots.children[i].removeAttribute('aria-current');
      }
      fenetre(actif);
      root.classList.toggle('bisou-gallery--scene', !!(c && c.hasAttribute('data-bisou-scene')));
    }

    var raf;
    list.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(marquer);
    }, { passive: true });

    /* Une largeur qui change (panneau « Édition limitée », fenêtre) : on reste sur la même diapo. */
    var tenue = null;
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () {
        if (tenue) aller(tenue, false);
      }).observe(list);
      list.addEventListener('scroll', function () { tenue = courante(); }, { passive: true });
    }

    /* La liste change (variante, scène retirée) : cercles refaits. */
    if ('MutationObserver' in window) {
      new MutationObserver(function () { construire(); }).observe(list, { childList: true });
    }
    document.addEventListener('bisou:gallery-changed', construire);

    /* ── Après un changement de variante : rester sur la scène, ou revenir à la vue principale ── */
    var garder = null;
    /* On regardait la vue principale : on y reste. Le thème remplace la vue principale (Dawn, updateMedia) ; si le
       focus était dedans (fermeture du zoom), le navigateur suivait l'ancienne diapo et la liste glissait d'un cran,
       sur la première scène. */
    var revenir = false, revenirMinuterie = null;
    var recaler = function () {
      var s = slides();
      if (s.length && courante() !== s[0]) aller(s[0], false);
      marquer();
    };
    /* le visiteur reprend la main (doigt, souris, flèches) : on ne le ramène plus */
    root.addEventListener('pointerdown', function () { revenir = false; }, true);
    root.addEventListener('touchstart', function () { revenir = false; }, { passive: true, capture: true });
    var gal = root.closest('media-gallery') || root;
    var patcher = function () {
      if (!gal || gal.__bisouPatch || typeof gal.setActiveMedia !== 'function') return;
      var orig = gal.setActiveMedia;
      gal.setActiveMedia = function (mediaId, prepend) {
        if (!garder) {
          var rendu = orig.apply(this, arguments);
          if (revenir) {
            revenir = false;
            recaler();
            setTimeout(recaler, 80);
            setTimeout(recaler, 400);
          }
          return rendu;
        }
        var cible = garder;
        /* le thème remet la liste sur la vue principale (setTimeout interne) : on neutralise ce défilement-là */
        var sv = list.scrollTo;
        list.scrollTo = function () {};
        try { return orig.apply(this, arguments); } finally {
          setTimeout(function () {
            delete list.scrollTo;
            if (list.scrollTo !== sv) list.scrollTo = sv;
            if (cible && cible.parentNode === list) aller(cible, false);
            garder = null;
            marquer();
          }, 60);
        }
      };
      gal.__bisouPatch = true;
    };
    if (window.customElements && customElements.whenDefined) customElements.whenDefined('media-gallery').then(patcher);
    else patcher();

    /* Le zoom (« Agrandir ») montre l'image de la vue principale. Quand le choix change sans que le thème recharge
       la galerie, bisou-variant-ui remplace l'image de la vue principale sur place, mais pas celle du zoom (le zoom
       nomme ses images sans le préfixe de section) : « Agrandir » ouvrait l'ancien format. On l'aligne ici. */
    var sansLargeur = function (u) { return String(u || '').replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, ''); };
    var synchroniserZoom = function () {
      var s = slides();
      var li = s[0];
      if (!li || li.hasAttribute('data-bisou-scene')) return;
      var im = li.querySelector('img');
      var src = im && sansLargeur(im.getAttribute('src'));
      if (!src) return;
      var id = String(li.getAttribute('data-media-id') || '').split('-').pop();
      var cible = id && document.querySelector('product-modal [data-media-id="' + id + '"]');
      if (!cible) return;
      var zi = cible.tagName === 'IMG' ? cible : cible.querySelector('img');
      if (!zi || sansLargeur(zi.getAttribute('src')).split('?')[0] === src.split('?')[0]) return;
      var sep = src.indexOf('?') === -1 ? '?' : '&';
      var jeu = zi.getAttribute('srcset');
      if (jeu) {
        zi.setAttribute('srcset', jeu.split(',').map(function (p) {
          var m = /\s(\d+)w\s*$/.exec(' ' + p.trim());
          return m ? src + sep + 'width=' + m[1] + ' ' + m[1] + 'w' : null;
        }).filter(Boolean).join(', '));
      }
      var m0 = /[?&]width=(\d+)/.exec(zi.getAttribute('src') || '');
      zi.setAttribute('src', src + sep + 'width=' + (m0 ? m0[1] : '1445'));
    };
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-rv5-expand], .product__media-toggle, .product__media-item img')) synchroniserZoom();
    }, true);

    document.addEventListener('bisou:variant-change', function (e) {
      var d = e.detail || {};
      var c = courante();
      var s = slides();
      synchroniserZoom();
      if (!c || c === s[0]) {
        garder = null;
        revenir = true;
        clearTimeout(revenirMinuterie);
        revenirMinuterie = setTimeout(function () { revenir = false; }, 4000);
        return;
      }
      var id = c.getAttribute('data-bisou-scene');
      var voulue = d.withFrame && d.color && d.color !== 'none' ? d.color : null;
      var bs = window.BisouScenes;
      if (id && bs && bs.changerait(id, d.format, voulue)) {
        garder = c;
        setTimeout(function () { if (garder === c) { garder = null; } }, 4000);
        return;
      }
      garder = null;
      revenir = true;
      clearTimeout(revenirMinuterie);
      revenirMinuterie = setTimeout(function () { revenir = false; }, 4000);
      aller(s[0]);
    });

    /* ── La boucle (Max, 29/10, au téléphone : « quand on arrive à la fin […] on devrait pouvoir encore swiper à droite
       et ça fait un tour. Sinon on est coincé à droite et on ne peut pas revenir au début ») ──
       Après la dernière diapo, la première ; avant la première, la dernière : au doigt, à la souris, au clavier et avec
       les flèches. Le saut ne refait pas tout le chemin en glissant : la liste se pose d'un coup sur la diapo d'arrivée,
       qui entre par le côté du geste. Les points suivent (défilement). Réversible : retirer ce bloc et ses trois appels. */
    var tourner = function (li, sens) {
      if (!li) return;
      /* l'élan du doigt (et le rebond d'iPhone au bout) reprendrait la main sur le saut : on le coupe le temps du saut */
      var ox = list.style.overflowX;
      list.style.overflowX = 'hidden';
      aller(li, false);
      list.style.overflowX = ox;
      /* la couleur des points et des flèches suit tout de suite la diapo d'arrivée (blanches sur une scène sombre,
         elles disparaissaient sur la vue principale le temps du calcul) */
      if (typeof tons === 'function') tons();
      var calme = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (calme || !li.animate) return;
      /* le contenu de la diapo, pas la diapo : l'aimant de la liste suivrait la diapo déplacée et effacerait l'entrée */
      Array.prototype.forEach.call(li.children, function (c) {
        c.animate([
          { transform: 'translateX(' + (sens * 12) + '%)', opacity: 0 },
          { transform: 'none', opacity: 1 }
        ], { duration: 380, easing: 'cubic-bezier(0.2, 0.7, 0.2, 1)' });
      });
    };
    /* la voisine de la diapo vue, en boucle ; sens 1 = la suivante */
    var voisine = function (sens, depuis) {
      var s = slides(), n = s.length;
      if (n < 2) return;
      var i = Math.max(0, s.indexOf(depuis || courante())), j = (i + sens + n) % n;
      if ((sens > 0 && j < i) || (sens < 0 && j > i)) tourner(s[j], sens);
      else aller(s[j]);
    };
    /* Les flèches : Dawn les grisait au bout (disabled) ; elles font le tour, sans jamais se griser. */
    viewer.enableSliderLooping = true;
    Array.prototype.forEach.call(root.querySelectorAll('.slider-button'), function (b) { b.removeAttribute('disabled'); });
    if (nav) nav.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('.slider-button') : null;
      if (!b || slides().length < 2) return;
      e.preventDefault();
      e.stopPropagation();
      voisine(b.name === 'next' ? 1 : -1);
    }, true);
    /* Au doigt, la liste défile seule ; au bout, elle ne bouge plus : un glisser franc vers l'extérieur fait le tour. */
    var doigt = null;
    list.addEventListener('touchstart', function (e) {
      doigt = null;
      if (e.touches.length !== 1) return;
      var s = slides(), n = s.length, i = s.indexOf(courante()), max = list.scrollWidth - list.clientWidth;
      var bout = n > 1 && i === n - 1 && list.scrollLeft >= max - 2 ? 1 : (n > 1 && i === 0 && list.scrollLeft <= 2 ? -1 : 0);
      if (bout) doigt = { x: e.touches[0].clientX, y: e.touches[0].clientY, bout: bout };
    }, { passive: true });
    list.addEventListener('touchend', function (e) {
      var d = doigt;
      doigt = null;
      if (!d || !e.changedTouches.length) return;
      var t = e.changedTouches[0], dx = t.clientX - d.x, dy = t.clientY - d.y;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      /* le bout se lit au début du geste : à la fin, l'élan ou le rebond peuvent avoir déplacé la liste */
      var s = slides();
      if (d.bout === 1 && dx < 0) tourner(s[0], 1);
      else if (d.bout === -1 && dx > 0) tourner(s[s.length - 1], -1);
    }, { passive: true });
    list.addEventListener('touchcancel', function () { doigt = null; }, { passive: true });

    /* Clavier : ← → quand la galerie a le focus, en boucle */
    gal.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      if (e.target && /input|textarea|select/i.test(e.target.tagName)) return;
      if (slides().length < 2) return;
      e.preventDefault();
      voisine(e.key === 'ArrowRight' ? 1 : -1);
    });

    /* Glisser à la souris (le doigt et le pavé tactile défilent déjà seuls). Un geste de plus de 6 px est un
       glisser : le clic qui suit n'ouvre pas le zoom. Lâché, on va à la diapo voisine dès un sixième de largeur. */
    var prise = null;
    list.addEventListener('dragstart', function (e) { if (slides().length > 1) e.preventDefault(); });
    list.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || slides().length < 2) return;
      prise = { id: e.pointerId, x: e.clientX, depart: list.scrollLeft, bouge: false, li: courante() };
    });
    window.addEventListener('pointermove', function (e) {
      if (!prise || e.pointerId !== prise.id) return;
      var dx = e.clientX - prise.x;
      if (!prise.bouge) {
        if (Math.abs(dx) < 6) return;
        prise.bouge = true;
        list.classList.add('is-glisse');
      }
      list.scrollLeft = prise.depart - dx;
    });
    var lacher = function (e) {
      if (!prise || e.pointerId !== prise.id) return;
      var p = prise;
      prise = null;
      if (!p.bouge) return;
      var s = slides(), i = Math.max(0, s.indexOf(p.li)), dx = e.clientX - p.x;
      var seuil = list.clientWidth / 6;
      /* au-delà d'un bout, le tour (la boucle, plus haut) */
      var sens = dx < -seuil ? 1 : (dx > seuil ? -1 : 0);
      var bloquer = function (ev) { ev.preventDefault(); ev.stopImmediatePropagation(); };
      window.addEventListener('click', bloquer, true);
      setTimeout(function () { window.removeEventListener('click', bloquer, true); }, 0);
      list.classList.remove('is-glisse');
      requestAnimationFrame(function () { if (sens) voisine(sens, s[i]); else aller(s[i]); });
    };
    window.addEventListener('pointerup', lacher);
    window.addEventListener('pointercancel', lacher);

    /* Ordinateur : le bloc gris est collant, haut d'un écran, et commence sous l'en-tête. Quand l'en-tête
       remonte ou redescend, la partie visible du bloc change : on recentre la galerie dessus (padding posé
       ici, transition dans la CSS). La hauteur disponible (--bg-dispo) se prend en-tête affiché, pour que
       l'image ne change pas de taille au défilement. */
    var bloc = root.closest('.product__media-wrapper');
    var entete = document.querySelector('.section-header') || document.querySelector('sticky-header');
    var enteteMax = 0, centrage = null, centrageFin = null, poses = {}, recouvre = false;
    var poser = function (nom, val) {
      if (poses[nom] === val) return;
      poses[nom] = val;
      bloc.style.setProperty(nom, val);
    };
    var centrer = function () {
      centrage = null;
      if (!bloc) return;
      if (getComputedStyle(bloc).position !== 'sticky') {
        bloc.classList.remove('bisou-centre');
        return;
      }
      var rb = bloc.getBoundingClientRect();
      /* en bas de la fiche, le bloc ne colle plus et remonte avec la page : on mesure depuis sa place collée
         (son « top »), jamais depuis son haut qui s'en va (sinon la marge suit le défilement, allonge le bloc
         et la page grandit sans fin) */
      var colle = parseFloat(getComputedStyle(bloc).top) || 0;
      /* Une fois le bloc collé et l'en-tête parti, l'en-tête qui revient quand on remonte recouvre le haut du bloc,
         comme partout sur le site (layout/theme.liquid), au lieu de pousser la galerie : elle redescendait après lui,
         d'un rebond (Max, 28/10 : « ça fait un espèce de rebond quand il y a le header qui apparaît. C'est pas fixe
         en fait notre bloc à gauche »). De retour en haut de la fiche, le bloc décolle et l'en-tête recompte ; sans fil
         d'Ariane (1 280 × 720), le bloc colle dès l'arrivée : la page revenue tout en haut suffit (relecture, 28/10). */
      if (document.documentElement.classList.contains('bisou-header-hidden')) recouvre = true;
      else if (rb.top > colle + 1 || window.scrollY < 1) recouvre = false;
      var bas = entete && !recouvre ? Math.max(0, entete.getBoundingClientRect().bottom) : 0;
      /* l'en-tête qui recouvre le bloc ne cache pas « Agrandir » : le bouton descend avec lui (bisou-product-gallery.css).
         Le bas de l'en-tête affiché, même pendant qu'il glisse (sa translation retirée), pour partir avec lui. */
      bloc.classList.toggle('bisou-recouvert', recouvre);
      if (entete && recouvre) {
        var tr = getComputedStyle(entete).transform, ty = 0;
        try { if (tr && tr !== 'none') ty = new DOMMatrixReadOnly(tr).m42; } catch (e) {}
        poser('--bg-entete', Math.max(0, Math.round(entete.getBoundingClientRect().bottom - ty - Math.max(rb.top, colle))) + 'px');
      }
      /* le fil d'Ariane, dans le flux sous l'en-tête, cache lui aussi le haut du bloc tant qu'on n'a pas défilé */
      var fil = document.querySelector('.bisou-pdp-crumb');
      if (fil && fil.getClientRects().length) bas = Math.max(bas, fil.getBoundingClientRect().bottom);
      enteteMax = Math.max(enteteMax, bas, rb.top);
      poser('--bg-haut', Math.max(0, Math.round(bas - Math.max(rb.top, colle))) + 'px');
      /* le bloc fait un écran de haut : ce qui en dépasse sous la fenêtre se mesure sur cette hauteur-là, jamais sur
         la hauteur que notre propre marge lui donnerait (sinon la marge s'auto-entretiendrait) */
      poser('--bg-bas', Math.max(0, Math.round(Math.min(rb.bottom, rb.top + window.innerHeight) - window.innerHeight)) + 'px');
      poser('--bg-dispo', Math.round(window.innerHeight - enteteMax) + 'px');
      /* la barre des points et des flèches va jusqu'aux coins du bloc (bisou-product-gallery.css) : l'écart entre
         la galerie, centrée, et le bord du bloc ; en largeurs de mise en page, que le zoom d'arrivée ne fausse pas */
      poser('--bg-cote', Math.max(0, Math.round((bloc.clientWidth - root.offsetWidth) / 2)) + 'px');
      /* les points et les flèches restent dans les coins bas du bloc, barre d'annonce et en-tête affichés ou non
         (Max, 21/10) : la barre reste dans le flux sous l'image et descend (--bg-descente) jusqu'à 1,4 rem du bas
         de la partie visible du bloc. Calculé sur les marges visées et en mise en page (offsetTop), jamais sur la
         place du moment : la marge du haut glisse en 0,35 s, la barre glisse d'autant et reste immobile à l'écran. */
      var descente = 0;
      if (nav && !nav.hidden) {
        var groupe = root;
        while (groupe.parentElement && groupe.parentElement !== bloc) groupe = groupe.parentElement;
        var basBarre = nav.offsetHeight, e = nav;
        while (e && e !== groupe && groupe.contains(e)) { basBarre += e.offsetTop; e = e.offsetParent; }
        if (e === groupe) {
          var libre = bloc.clientHeight - parseFloat(poses['--bg-haut']) - parseFloat(poses['--bg-bas']) - groupe.offsetHeight;
          descente = Math.max(0, Math.round(libre / 2 + groupe.offsetHeight - basBarre - 14));
        }
      }
      poser('--bg-descente', descente + 'px');
      /* les diapos prennent toute la partie visible du bloc, en largeur et en hauteur (Max, 23/10 : « quand je défile, les
         images ne font pas la taille exacte de l'ensemble du bloc de gauche, ça doit vraiment être complet » ; fiche
         wk-produit-galerie-scroll-droite) : sa hauteur (--bg-vue) et sa forme (--bg-boite, largeur / hauteur), que la
         scène couvre (bisou-product-gallery.css) */
      var vue = Math.max(1, bloc.clientHeight - parseFloat(poses['--bg-haut']) - parseFloat(poses['--bg-bas']));
      poser('--bg-vue', vue + 'px');
      poser('--bg-boite', (bloc.clientWidth / vue).toFixed(4));
      if (!bloc.classList.contains('bisou-centre')) {
        bloc.classList.add('bisou-centre');
        /* le fondu du tirage (bisou-product-gallery.css) ne joue qu'à l'arrivée, jamais quand la vue est redessinée */
        bloc.classList.add('bisou-arrivee');
        setTimeout(function () { bloc.classList.remove('bisou-arrivee'); }, 700);
        /* la première pose ne glisse pas : la page arrive déjà centrée */
        requestAnimationFrame(function () { requestAnimationFrame(function () { bloc.classList.add('bisou-centre--anim'); }); });
      }
    };
    var demanderCentrage = function () {
      if (!centrage) centrage = requestAnimationFrame(centrer);
      /* l'en-tête glisse encore un instant après le dernier défilement */
      clearTimeout(centrageFin);
      centrageFin = setTimeout(centrer, 400);
    };
    window.addEventListener('scroll', demanderCentrage, { passive: true });
    window.addEventListener('resize', function () { enteteMax = 0; demanderCentrage(); });
    if (entete) entete.addEventListener('transitionend', demanderCentrage);
    /* la galerie change de largeur (format, panneau « Édition limitée ») : la barre se recale dans les coins */
    if ('ResizeObserver' in window) new ResizeObserver(demanderCentrage).observe(root);
    centrer();

    /* Ordinateur : un premier cran de molette vers le bas cadre la fiche d'un coup (Max, 23/10, 14 h : « un léger
       scroll bas et ça enlève tout du haut, donc plus de header, annonce, Ariane, car là il faut doser 3 scrolls » ;
       fiche wk-produit-galerie-scroll-droite) : la page glisse jusque sous le fil d'Ariane, l'en-tête remonte, le bloc
       de l'image remplit la fenêtre. Plus bas, la molette reprend sa course normale. Pas quand un tiroir ou une
       fenêtre est ouvert, ni dans une zone qui défile elle-même. */
    var finDuHaut = function () {
      var fil = document.querySelector('.bisou-pdp-crumb');
      var e = fil && fil.getClientRects().length ? fil : bloc;
      return Math.round(e.getBoundingClientRect()[e === fil ? 'bottom' : 'top'] + window.scrollY);
    };
    var principal = document.getElementById('MainContent') || document.body;
    /* le glissé, image par image, d'au moins un pixel à chaque image : le contrôleur de l'en-tête (layout/theme.liquid)
       relit la position à chaque image et prend une position qui n'a pas bougé pour une remontée (il rouvrait l'en-tête
       à la fin d'un scrollTo « smooth »). Chaque pas se pose après l'image (setTimeout), jamais avant sa lecture. */
    var glisse = null;
    var glisser = function (cible) {
      var y0 = window.scrollY, d = cible - y0, t0 = null, dernier = Math.round(y0);
      var pas = function (t) {
        if (t0 === null) t0 = t;
        var p = Math.min(1, (t - t0) / 450);
        var y = Math.min(cible, Math.max(dernier + 1, Math.round(y0 + d * (1 - Math.pow(1 - p, 3)))));
        if (p >= 1) y = cible;
        dernier = y;
        setTimeout(function () { if (y > window.scrollY) window.scrollTo({ top: y, behavior: 'instant' }); }, 0);
        glisse = y < cible ? requestAnimationFrame(pas) : null;
        if (!glisse) finCadrage = performance.now();
      };
      glisse = requestAnimationFrame(pas);
    };
    /* La geste qui cadre ne fait que cadrer (fiche reprise-wk-produit-galerie-trackpad-inertie, 23/10) : au trackpad, la
       rafale et son inertie continuent après le glissé et emmenaient la page bien plus bas. Les crans vers le bas qui
       suivent sans pause (moins de 250 ms entre deux) sont avalés : 1,2 s après la fin du glissé, puis tant qu'ils restent
       sous le plus fort cran de la geste (l'inertie retombe). Une pause, un cran vers le haut, de côté (les images) ou un
       pincement, une molette tournée à vitesse égale ou une poussée plus forte rendent la main. L'écart se lit à l'heure
       des crans (timeStamp) ; un pavé en envoie un toutes les 16 ms, mais pendant le glissé la page les reçoit groupés
       (jusqu'à 170 ms d'écart mesurés, 23/10). Sur un PC occupé, Chrome groupe aussi les crans de souris (deltaY 200
       pour deux crans de 100) et le pic restait à 200 : deux crans égaux d'au moins 30 qui se suivent, dont le pic vaut
       tout juste 2, 3 ou 4 fois, ramènent le pic à un cran (fiche reprise-wk-produit-galerie-molette-groupee, 23/10). */
    /* La molette qu'on continue de tourner, elle, continue de descendre (Max, 27/10 : « quand on scrolle pour faire afficher
       la suite […] ça rame, c'est un peu buggé » ; fiche b27-fiche-cadrage-defilement) : ses crans étaient avalés 1,2 s
       après le glissé, la page restait figée 1,6 s sous la main. Un cran de molette (le même que le précédent, 50 au moins,
       espacé d'au moins 20 ms, jamais sous le pic) rend la main dès la fin du glissé ; l'inertie du pavé (des crans qui
       retombent, toutes les 8 à 16 ms) reste avalée comme avant. */
    var suite = false, finCadrage = 0, dernierCran = -Infinity, pic = 0, dernierDy = 0;
    window.addEventListener('wheel', function (e) {
      var t = performance.now(), ecart = e.timeStamp - dernierCran, dy = Math.abs(e.deltaY), fois = pic / dy;
      var cranMolette = dy >= 50 && dy === dernierDy && ecart >= 20;
      if (dy >= 30 && dy === dernierDy && fois > 1.5 && fois < 4.5 && Math.abs(fois - Math.round(fois)) < 0.01) pic = dy;
      var sousPic = dy < pic;
      dernierCran = e.timeStamp;
      dernierDy = dy;
      pic = Math.max(pic, dy);
      if (e.deltaY <= 0 || e.ctrlKey || Math.abs(e.deltaX) > dy) suite = false;
      if (glisse && e.deltaY > 0) { e.preventDefault(); return; }
      if (suite && ecart < 250 && (t - finCadrage < 1200 || sousPic) && !(cranMolette && !sousPic)) { e.preventDefault(); return; }
      suite = false;
      if (!bloc || e.deltaY <= 0 || e.ctrlKey || e.shiftKey) return;
      if (getComputedStyle(bloc).position !== 'sticky' || !principal.contains(e.target)) return;
      if (getComputedStyle(document.body).overflow === 'hidden' || getComputedStyle(document.documentElement).overflow === 'hidden') return;
      for (var n = e.target; n && n !== principal; n = n.parentElement) {
        var oy = getComputedStyle(n).overflowY;
        if ((oy === 'auto' || oy === 'scroll') && n.scrollHeight > n.clientHeight + 1) return;
      }
      var cible = finDuHaut();
      if (window.scrollY >= cible - 2) return;
      e.preventDefault();
      suite = true;
      pic = dy;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.scrollTo({ top: cible, behavior: 'instant' });
        finCadrage = t;
      } else glisser(cible);
    }, { passive: false });

    /* La vue principale nette dans le carré (fiche parcours-scenes-pleine-page-v6, 22/10) : l'attribut sizes du thème
       (825 px au plus) faisait servir une image plus petite que sa boîte, agrandie et floue sur grand écran. On donne
       au navigateur la largeur réelle de la boîte ; il choisit lui-même dans le srcset. */
    var nettete = function () {
      Array.prototype.forEach.call(list.querySelectorAll('.product__media-item:not(.bisou-scene-slide) .product-media-container img[srcset]'), function (im) {
        var w = Math.ceil(im.closest('.product-media-container').clientWidth);
        if (w > 0 && im.getAttribute('sizes') !== w + 'px') im.setAttribute('sizes', w + 'px');
      });
    };
    if ('ResizeObserver' in window) new ResizeObserver(nettete).observe(root);
    if ('MutationObserver' in window) new MutationObserver(nettete).observe(list, { childList: true, subtree: true });
    nettete();

    /* La couleur des flèches et des points suit l'image sous eux (fiche parcours-galerie-carre-v7, Max, 22/10 : « En blanc,
       ça alterne en fonction de la couleur du fond du mock-up ») : on peint dans un petit canevas, à la place de chacun, ce
       que la diapo montre (la pièce et ses calques, ou le tirage sur le gris du bloc), et on garde le ton qui contraste le
       plus, blanc ou encre (data-bisou-ton, bisou-product-gallery.css). Une image d'un autre domaine rend le canevas
       illisible : on retire le ton, la pastille claire d'avant revient. */
    var toile = document.createElement('canvas');
    var lin = function (c) { c /= 255; return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); };
    var fondDe = function (e) {
      for (; e && e !== document.documentElement; e = e.parentElement) {
        var b = getComputedStyle(e).backgroundColor, m = /rgba?\(([\d.]+),\s*([\d.]+),\s*([\d.]+)(?:,\s*([\d.]+))?/.exec(b);
        if (m && (m[4] === undefined || parseFloat(m[4]) > 0.5)) return b;
      }
      return '#fff';
    };
    var tonSous = function (li, z) {
      var k = 1, w = Math.max(1, Math.round(z.width * k)), h = Math.max(1, Math.round(z.height * k));
      toile.width = w; toile.height = h;
      var cx = toile.getContext('2d', { willReadFrequently: true });
      cx.fillStyle = fondDe(li);
      cx.fillRect(0, 0, w, h);
      Array.prototype.forEach.call(li.querySelectorAll('img'), function (im) {
        if (!im.complete || !im.naturalWidth) return;
        var cs = getComputedStyle(im), r = im.getBoundingClientRect();
        if (cs.visibility === 'hidden' || !r.width || !r.height) return;
        var nw = im.naturalWidth, nh = im.naturalHeight, dw = r.width, dh = r.height;
        if (cs.objectFit === 'cover' || cs.objectFit === 'contain') {
          var s = (cs.objectFit === 'cover' ? Math.max : Math.min)(r.width / nw, r.height / nh);
          dw = nw * s; dh = nh * s;
        }
        var pos = cs.objectPosition.split(' ');
        var px = /%$/.test(pos[0]) ? parseFloat(pos[0]) / 100 : 0.5, py = /%$/.test(pos[1] || '') ? parseFloat(pos[1]) / 100 : 0.5;
        cx.globalAlpha = Math.min(1, parseFloat(cs.opacity) || 0);
        cx.drawImage(im, (r.left + (r.width - dw) * px - z.left) * k, (r.top + (r.height - dh) * py - z.top) * k, dw * k, dh * k);
      });
      /* pixel par pixel, pas en moyenne (en A2, le bord du cadre noir passe sous la flèche, entre le gris et le
         passe-partout : la moyenne donnait l'encre, posée sur le noir) : sous 3:1 avec l'encre du thème (18, 18, 18 :
         0,006) en dessous de 0,118, avec le blanc au-dessus de 0,30. On garde le ton qui laisse le moins de pixels
         illisibles ; s'il en reste trop (fond moitié noir, moitié clair), un liseré du ton opposé (data-bisou-liseret). */
      var d = cx.getImageData(0, 0, w, h).data, n = d.length / 4, sousEncre = 0, sousBlanc = 0;
      for (var i = 0; i < d.length; i += 4) {
        var y = 0.2126 * lin(d[i]) + 0.7152 * lin(d[i + 1]) + 0.0722 * lin(d[i + 2]);
        if (y < 0.118) sousEncre++; else if (y > 0.3) sousBlanc++;
      }
      var t = sousEncre > sousBlanc ? 'sombre' : 'clair';
      return { ton: t, liseret: (t === 'sombre' ? sousBlanc : sousEncre) / n > 0.1 };
    };
    var tons = function () {
      if (!nav || nav.hidden) return;
      var li = courante();
      /* « Agrandir » aussi, en haut à droite du bloc : sur une scène il n'a plus de rond clair (a26-fiche-commandes-image) */
      var els = [dots, root.querySelector('.slider-button--prev'), root.querySelector('.slider-button--next'), document.querySelector('.rv5-expand-btn')];
      try {
        els.forEach(function (e) {
          if (!e) return;
          var z = e.getBoundingClientRect();
          if (!li || !z.width || !z.height) { e.removeAttribute('data-bisou-ton'); e.removeAttribute('data-bisou-liseret'); return; }
          /* une flèche : sous le trait dessiné (et 2 px autour), pas sous toute la case de 44 px */
          var ic = e.querySelector('svg path'), zi = ic && ic.getBoundingClientRect();
          if (zi && zi.width && zi.height) z = { left: zi.left - 2, top: zi.top - 2, width: zi.width + 4, height: zi.height + 4 };
          var t = tonSous(li, z);
          if (e.getAttribute('data-bisou-ton') !== t.ton) e.setAttribute('data-bisou-ton', t.ton);
          if (e.hasAttribute('data-bisou-liseret') !== t.liseret) e.toggleAttribute('data-bisou-liseret', t.liseret);
        });
      } catch (err) {
        els.forEach(function (e) { if (e) { e.removeAttribute('data-bisou-ton'); e.removeAttribute('data-bisou-liseret'); } });
      }
    };
    var tonsMinuterie = null;
    var demanderTons = function () { clearTimeout(tonsMinuterie); tonsMinuterie = setTimeout(tons, 120); };
    list.addEventListener('scroll', demanderTons, { passive: true });
    /* une image chargée (la pièce d'une scène, la vue d'une autre variante) change ce qu'il y a sous les flèches */
    list.addEventListener('load', demanderTons, true);
    window.addEventListener('resize', demanderTons);
    document.addEventListener('bisou:gallery-changed', demanderTons);
    if ('ResizeObserver' in window) new ResizeObserver(demanderTons).observe(root);
    if ('MutationObserver' in window) new MutationObserver(demanderTons).observe(list, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'src'] });

    /* Changer de format (A4 → A3 → A2) : le cadre passe d'une taille à l'autre en 0,3 s au lieu de sauter (Max, 26/10 :
       « bosser une transition légère entre le changement de taille de cadre » ; fiche a26-fiche-premier-ecran).
       bisou-variant-ui remplace l'image du tirage sur place (src) : l'ancienne reste posée par-dessus le temps que la
       nouvelle soit prête, puis l'une grandit (ou rétrécit) vers l'autre en fondu, sans rebond. L'écart de taille se lit
       sur les images (la part de largeur que le tirage, cadre compris, occupe dans son canevas, transparent ou clair) ; illisible,
       c'est un simple fondu. Ordinateur seulement ; rien en mouvement réduit. */
    var bureau = window.matchMedia('(min-width: 900px)'), calme = window.matchMedia('(prefers-reduced-motion: reduce)');
    var partDuCanevas = function (im) {
      try {
        if (!im.complete || !im.naturalWidth) return 0;
        var w = 120, h = Math.max(1, Math.round(w * im.naturalHeight / im.naturalWidth));
        var c = document.createElement('canvas');
        c.width = w; c.height = h;
        var x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(im, 0, 0, w, h);
        /* le tirage : ce qui est opaque (l'ombre douce des rendus touche les bords du canevas) et, sur un fond opaque,
           pas de la couleur du coin */
        var d = x.getImageData(0, 0, w, h).data, g = w, dr = -1, hh = h, bs = -1, k0 = d[3] > 24;
        for (var j = 0; j < h; j++) for (var i = 0; i < w; i++) {
          var p = (j * w + i) * 4;
          if (d[p + 3] > 200 && (!k0 || Math.abs(d[p] - d[0]) + Math.abs(d[p + 1] - d[1]) + Math.abs(d[p + 2] - d[2]) > 36)) { if (i < g) g = i; if (i > dr) dr = i; if (j < hh) hh = j; if (j > bs) bs = j; }
        }
        /* en largeur et en hauteur : A4, A3 et A2 encadrés n'ont pas tout à fait les mêmes proportions */
        return dr < g ? 0 : { l: (dr - g + 1) / w, h: (bs - hh + 1) / h };
      } catch (e) { return 0; }
    };
    /* Dawn (product-info.js, updateMedia) remplace ensuite le li du tirage quand le HTML de la section revient (200 à 1 000 ms
       après le clic, selon le réseau) : le fantôme passe dans le nouveau li et l'animation y reprend au même instant, sur la
       nouvelle image. Elle joue ainsi une fois, en entier, que Dawn remplace le li ou non. */
    var sansReglages = function (s) { return String(s).split('?')[0]; };
    var fmt = null, temps = { duration: 300, easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)' };
    /* chargée puis décodée ; mais decode() peut tarder bien après le chargement (machine chargée) : pas plus de 100 ms d'attente
       une fois l'image chargée, sinon le changement partirait plus tard qu'avant la transition */
    var pret = function (e) {
      var charge = e.complete && e.naturalWidth ? Promise.resolve() : new Promise(function (r) { e.addEventListener('load', r, { once: true }); e.addEventListener('error', r, { once: true }); });
      if (!e.decode) return charge;
      return Promise.race([e.decode(), charge.then(function () { return new Promise(function (r) { setTimeout(r, 100); }); })]);
    };
    var poserSur = function (im, avant) {
      var cs = getComputedStyle(im);
      avant.style.cssText = 'position:absolute;z-index:1;pointer-events:none;animation:none;object-fit:' + cs.objectFit + ';object-position:' + cs.objectPosition +
        ';top:' + cs.top + ';left:' + cs.left + ';width:' + cs.width + ';height:' + cs.height;
      im.parentElement.appendChild(avant);
    };
    /* la nouvelle image est pleine dès 30 % de la course et l'ancienne s'efface par-dessus : deux images à moitié transparentes
       laissaient voir le mur à mi-chemin (photo délavée). Le fantôme suit aussi la hauteur du nouveau cadre (sinon double trait). */
    var animer = function (f, t) {
      var o = f.o;
      f.anims = [
        f.im.animate([{ opacity: 0, transform: 'scale(' + f.k + ')', transformOrigin: o }, { opacity: 1, offset: 0.3 }, { opacity: 1, transform: 'none', transformOrigin: o }], temps),
        f.avant.animate([{ opacity: 1, transform: 'none', transformOrigin: o }, { opacity: 0, transform: 'scale(' + (1 / f.k) + ',' + (1 / f.ky) + ')', transformOrigin: o }], Object.assign({ fill: 'forwards' }, temps))
      ];
      if (t) f.anims.forEach(function (a) { a.currentTime = t; });
      f.anims[1].onfinish = function () { f.avant.remove(); if (fmt === f) fmt = null; };
    };
    /* tant que rien ne joue, la nouvelle image reste cachée sous le fantôme : les rendus ont un canevas transparent, un cadre
       plus grand dépasserait autour de l'ancien. Garde bornée à 2 s : l'image ne peut pas rester cachée. */
    var cacher = function (f) { if (f.garde) f.garde.cancel(); f.garde = f.im.animate([{ opacity: 0 }, { opacity: 0 }], { duration: 2000 }); };
    var lever = function (f) { if (f.garde) f.garde.cancel(); f.garde = null; };
    var jouer = function (f, quandMeme) {
      if (f !== fmt || f.anims) return;
      /* l'image d'un format déjà quitté (voir nouveauLi) ne joue qu'en dernier recours */
      if (!quandMeme && sansReglages(f.im.getAttribute('src')) !== f.voulu) return;
      lever(f);
      /* la taille affichée (« contain » dans la même boîte : les rendus recadrés serrés changent de forme d'un format à
         l'autre), puis la part du canevas qu'occupe le tirage (rendus à canevas transparent) */
      var cs = getComputedStyle(f.im), bw = parseFloat(cs.width) || 1, bh = parseFloat(cs.height) || 1;
      var aire = function (e) { if (!e.naturalWidth) return 0; var s = Math.min(bw / e.naturalWidth, bh / e.naturalHeight); return e.naturalWidth * e.naturalHeight * s * s; };
      var sa = aire(f.avant), sb = aire(f.im), a = partDuCanevas(f.avant), b = partDuCanevas(f.im), s = sa && sb ? Math.sqrt(sa / sb) : 1;
      var k = s * (a && b ? a.l / b.l : 1), ky = s * (a && b ? a.h / b.h : 1);
      f.k = k > 0.4 && k < 2.5 ? k : 1;
      /* les cadres d'un même tirage diffèrent jusqu'à 12 % en proportions d'un format à l'autre ; au-delà de 25 %, la hauteur
         est mal lue : la même échelle */
      f.ky = Math.abs(ky / f.k - 1) < 0.25 ? ky : f.k;
      f.o = cs.objectPosition;
      animer(f, 0);
    };
    /* les deux images prêtes (l'ancienne n'est pas toujours en cache sous cette adresse), puis on joue */
    var attendre = function (f) { var go = function () { jouer(f); }; Promise.all([pret(f.im), pret(f.avant)]).then(go, go); };
    /* l'adresse que chaque image affiche, notée à son chargement : quand le nouveau format est déjà en cache, currentSrc a
       basculé au moment du clic, et le fantôme serait la nouvelle image (l'ancien cadre disparaîtrait d'un coup) */
    var vues = new WeakMap();
    var noter = function (e) { if (e && e.tagName === 'IMG' && e.currentSrc && !e.classList.contains('bg-format-avant')) vues.set(e, e.currentSrc); };
    list.addEventListener('load', function (e) { noter(e.target); }, true);
    Array.prototype.forEach.call(list.querySelectorAll('img'), function (e) { if (e.complete) noter(e); });
    var changerFormat = function (im, ancienSrc) {
      var f = fmt;
      if (f && !f.anims && f.avant.isConnected) {
        /* second clic avant que le premier ait joué : le fantôme garde l'image encore à l'écran */
        f.im = im;
        f.voulu = sansReglages(im.getAttribute('src'));
        cacher(f);
        attendre(f);
        return;
      }
      var dessus = null;
      if (f && f.anims && f.avant.isConnected && f.anims[1].playState === 'running') {
        /* second clic pendant la transition : l'ancien fantôme finit de s'effacer par-dessus, rien ne saute */
        f.anims[0].cancel();
        dessus = f.avant;
      } else if (f) { lever(f); if (f.anims) f.anims.forEach(function (a) { a.cancel(); }); f.avant.remove(); }
      var avant = document.createElement('img');
      avant.className = 'bg-format-avant';
      avant.alt = '';
      avant.setAttribute('aria-hidden', 'true');
      /* l'image affichée, déjà chargée : avec un srcset, ce n'est pas l'ancien src (jamais chargé, le fantôme serait vide) */
      var vu = vues.get(im) || im.currentSrc;
      avant.src = vu && sansReglages(vu) !== sansReglages(im.src) ? vu : ancienSrc;
      poserSur(im, avant);
      if (dessus && dessus.parentNode === avant.parentNode) avant.parentNode.insertBefore(avant, dessus);
      f = fmt = { im: im, avant: avant, dessus: dessus, anims: null, k: 1, ky: 1, o: '', garde: null, voulu: sansReglages(im.getAttribute('src')) };
      cacher(f);
      attendre(f);
      setTimeout(function () { jouer(f); }, 1500);
    };
    var nouveauLi = function (li) {
      var f = fmt;
      if (!f || li.nodeType !== 1 || !li.classList.contains('product__media-item') || li.classList.contains('bisou-scene-slide')) return;
      var im = li.querySelector('.media > img:not(.bg-format-avant)');
      if (!im) return;
      var t = f.anims ? f.anims[0].currentTime : 0;
      if (f.anims) f.anims.forEach(function (a) { a.cancel(); });
      poserSur(im, f.avant);
      /* double clic : l'ancien fantôme, qui finit de s'effacer par-dessus, suit aussi (retiré à la fin de son fondu) */
      if (f.dessus && f.dessus.parentNode) poserSur(im, f.dessus);
      f.im = im;
      if (sansReglages(im.getAttribute('src')) !== f.voulu && f.avant.complete && f.avant.naturalWidth) {
        /* double clic : la réponse de Dawn pour le format qu'on vient de quitter arrive dans les 50 ms où bisou-variant-ui
           attend avant de lui demander le nouveau ; elle remet l'ancien format. Le fantôme reste dessus, cette image cachée,
           jusqu'au li du dernier format demandé (ou, faute de li, la transition joue sur celle-ci au plus tard 1,5 s après).
           Fantôme pas chargé : on ne tient pas un blanc, la suite fait comme avant la transition */
        f.anims = null;
        cacher(f);
        setTimeout(function () { jouer(f, true); }, 1500);
        return;
      }
      if (!f.anims) {
        /* l'ancienne image pas encore chargée : pas de transition, la nouvelle s'affiche comme avant (sans attendre) */
        if (!f.avant.complete || !f.avant.naturalWidth) { lever(f); f.avant.remove(); fmt = null; return; }
        cacher(f);
        attendre(f);
        return;
      }
      animer(f, t);
      if (!im.complete || !im.naturalWidth) {
        /* nouvelle image pas encore prête : l'animation attend, figée là où elle en était */
        f.anims.forEach(function (a) { a.pause(); });
        var go = function () { if (fmt === f) f.anims.forEach(function (a) { a.play(); }); };
        pret(im).then(go, go);
      }
    };
    if ('MutationObserver' in window) new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        if (m.type === 'childList') { m.addedNodes.forEach(nouveauLi); return; }
        if (!bureau.matches || calme.matches) return;
        var im = m.target;
        if (im.tagName !== 'IMG' || !m.oldValue || im.classList.contains('bg-format-avant') || im.getAttribute('src') === m.oldValue) return;
        var li = im.closest('.product__media-item');
        if (!li || li.classList.contains('bisou-scene-slide') || !im.parentElement.classList.contains('media')) return;
        /* même rendu à une autre largeur : rien à faire */
        if (sansReglages(im.getAttribute('src')) === sansReglages(m.oldValue)) return;
        changerFormat(im, m.oldValue);
      });
    }).observe(list, { subtree: true, childList: true, attributes: true, attributeFilter: ['src'], attributeOldValue: true });

    /* Les transitions partent plus vite (Max, 27/10 : « je sais pas si ça peut charger un poil plus rapidement […] en termes
       de délai » ; fiche b27-fiche-cadrage-defilement). Le délai, c'était le chargement : le tirage d'un autre format (adresse
       de bisou-variant-ui, rv5-variants) et, sur une scène, les calques de l'autre format (adresses du moteur, BisouScenes).
       Une fois la fiche affichée et le navigateur au repos, on les charge et on les décode d'avance : les autres formats de la
       finition choisie, pour la vue principale et pour la scène regardée (la première scène d'abord). L'animation ne change
       pas. Ordinateur seulement, pas en économie de données. */
    var dejaPris = {};
    var prendre = function (url) {
      if (!url || dejaPris[url]) return;
      dejaPris[url] = true;
      var im = new Image();
      im.decoding = 'async';
      im.onload = function () { if (im.decode) im.decode().catch(function () {}); };
      im.src = url;
    };
    /* la vue principale ne montre pas l'adresse du tirage (width=1600) mais la largeur que le navigateur prend dans son
       srcset, refait par bisou-variant-ui pour l'autre format avec les mêmes largeurs (width=823 à 1 440 × 900) : on
       précharge par le même srcset et le même sizes, le navigateur choisit la même (relecture, 27/10 : A4 restait à 450 ms) */
    var prendreVue = function (url) {
      var vue = list.querySelector('.product__media-item:not(.bisou-scene-slide) .product-media-container img[srcset]');
      var modele = vue && vue.getAttribute('srcset');
      if (!url || !modele) return prendre(url);
      var base = String(url).replace(/([?&])width=\d+(&|$)/, function (m, a, b) { return b ? a : ''; });
      var sep = base.indexOf('?') === -1 ? '?' : '&';
      var ss = modele.split(',').map(function (p) {
        var m = /\s(\d+)w\s*$/.exec(' ' + p.trim());
        return m ? base + sep + 'width=' + m[1] + ' ' + m[1] + 'w' : '';
      }).filter(Boolean).join(', ');
      var sz = vue.getAttribute('sizes') || '100vw';
      if (!ss || dejaPris[ss + '|' + sz]) return;
      dejaPris[ss + '|' + sz] = true;
      var im = new Image();
      im.decoding = 'async';
      im.onload = function () { if (im.decode) im.decode().catch(function () {}); };
      im.sizes = sz;
      im.srcset = ss;
    };
    var variantes = null;
    var autresFormats = function () {
      if (!variantes) {
        try { variantes = JSON.parse((document.querySelector('script[id^="rv5-variants-"]') || {}).textContent || '[]'); } catch (e) { variantes = []; }
      }
      /* la variante choisie : le champ du formulaire de la fiche (pas celui d'« Associez-le »), sinon l'adresse */
      var champ = document.querySelector('form[id^="product-form-"] [name="id"]');
      var id = String((champ && champ.value) || new URLSearchParams(location.search).get('variant') || '');
      var v = null;
      for (var i = 0; i < variantes.length; i++) if (String(variantes[i].id) === id) v = variantes[i];
      if (!v || !v.o) return [];
      /* l'option du format : celle qui nomme A4, A3 ou A2 */
      var k = -1;
      v.o.forEach(function (x, i) { if (/\bA[2-4]\b/i.test(String(x))) k = i; });
      if (k < 0) return [];
      return variantes.filter(function (w) {
        if (w === v || !w.o || !w.img) return false;
        for (var i = 0; i < w.o.length; i++) if (i !== k && w.o[i] !== v.o[i]) return false;
        return true;
      });
    };
    var prechargerScene = function (id) {
      var bs = window.BisouScenes, sc = null;
      if (!bs || !bs.scenes) return;
      bs.scenes.forEach(function (x) { if (x.s && x.s.id === id) sc = x; });
      if (!sc || !sc.actif || !sc.fmt || !sc.coul || typeof sc.urlCadre !== 'function') return;
      Object.keys(sc.s.formats || {}).forEach(function (f) {
        if (f === sc.fmt) return;
        try {
          prendre(sc.urlCadre(f, sc.coul));
          var mx = typeof sc.urlsMixte === 'function' && sc.urlsMixte(f, sc.coul);
          if (mx) Object.keys(mx).forEach(function (n) { prendre(mx[n]); });
        } catch (e) {}
      });
    };
    var economie = function () { var c = navigator.connection; return !!(c && (c.saveData || /2g/.test(c.effectiveType || ''))); };
    var auRepos = function (fn) { if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 2000 }); else setTimeout(fn, 300); };
    var prechargerTout = function () {
      if (!bureau.matches || economie()) return;
      auRepos(function () {
        autresFormats().forEach(function (w) { prendreVue(w.img); });
        var c = courante(), s = slides();
        var id = c && c.getAttribute('data-bisou-scene');
        if (!id) { var sc1 = s.filter(function (li) { return li.hasAttribute('data-bisou-scene'); })[0]; id = sc1 && sc1.getAttribute('data-bisou-scene'); }
        if (id) prechargerScene(id);
      });
    };
    var lancerPrechargement = function () {
      /* après la vue principale et les pièces des scènes (le moteur les charge au repos, au plus tard 2,5 s après) */
      setTimeout(prechargerTout, 2800);
    };
    if (document.readyState === 'complete') lancerPrechargement();
    else window.addEventListener('load', lancerPrechargement, { once: true });
    /* une autre finition, une autre scène regardée : leurs autres formats, une fois le changement posé */
    var prechargementMinuterie = null;
    var prechargerBientot = function () { clearTimeout(prechargementMinuterie); prechargementMinuterie = setTimeout(prechargerTout, 900); };
    document.addEventListener('bisou:variant-change', prechargerBientot);
    list.addEventListener('scroll', prechargerBientot, { passive: true });

    construire();
    demanderTons();
    window.addEventListener('resize', marquer);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();